import { ProductCategory } from "@/core/common/types";
import { RenderPipelineArgs } from "@/core/common/types/render-args";
import { createSolidColorImageDataURL } from "@/core/utils/image-utils";
import { ImageGenerationFromDndRequest } from "./image-generation-from-dnd-manager";

const DEFAULT_RENDER_LENGTH = 1024;

export function getImageGenerationFromDndRequest({
  renderPipelineArgs,
  publicTeamId,
}: {
  renderPipelineArgs: RenderPipelineArgs;
  publicTeamId: string;
}): ImageGenerationFromDndRequest {
  const {
    prompt,
    num_images: numOutputs = 1,
    width = DEFAULT_RENDER_LENGTH,
    height = DEFAULT_RENDER_LENGTH,
  } = renderPipelineArgs;

  const imageUrls = [
    "composite_image" in renderPipelineArgs ? renderPipelineArgs.composite_image : undefined,
    "ref_image" in renderPipelineArgs ? renderPipelineArgs.ref_image : undefined,
  ].filter((image): image is string => Boolean(image));

  return {
    // The handler needs a reference image, so an empty frame is sent as a blank page.
    imageUrls:
      imageUrls.length > 0 ? imageUrls : [createSolidColorImageDataURL(width, height, "#fff")],
    aspectRatio: `${width}x${height}`,
    promptObj: {
      additionalPrompting: prompt,
    },
    productCategory: ProductCategory.Other,
    numOutputs,
    width,
    height,
    publicTeamId,
  };
}
